module.exports = __webpack_public_path__ + "static/media/gallery2.2468bb02.jpeg";